import { render, staticRenderFns } from "./TableHeadRow.vue?vue&type=template&id=2ecb3904&"
import script from "./TableHeadRow.vue?vue&type=script&lang=js&"
export * from "./TableHeadRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports